import { Box, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { IRootStore } from "../../stores";
import { LockedForm } from "../../tutor-revamp/forms/SharedComponents";
import { FormsetWrapper } from "../../components/FormWrapper";
import { useTutorApplicationFlow } from "./data";

export { useTutorApplicationFlow };

const VerificationWrapper: React.FC<{
  activeForm?: number;
  currentEditableForm: string;
  rootStore: IRootStore;
  [key: string]: any;
}> = observer(
  ({ children, activeForm = 1, rootStore, currentEditableForm, ...rest }) => {
    return (
      <VStack justifyContent="stretch" alignItems="stretch" spacing={[8, 12]}>
        {React.Children.map(children, (child: any, index) => {
          let {
            isCompleted = false,
            formHeader = "",
            label,
            lockedDescription = "",
            displayType,
            ...otherProps
          } = child.props;
          if (displayType === "complex") {
            return (
              <Box
                p={[0, 10]}
                borderWidth={["none", "2xs"]}
                borderColor="neutral.500"
                boxShadow={["none", "base"]}
                rounded="lg"
              >
                <FormsetWrapper
                  header={formHeader}
                  description={otherProps.description}
                  shouldDisplayButton={otherProps.shouldDisplayButton}
                  hideStep
                >
                  {child}
                </FormsetWrapper>
              </Box>
            );
          }
          if (rootStore.currentEditableForm === label) {
            return child;
          }
          return child;
        })}
      </VStack>
    );
  },
);

export default VerificationWrapper;
